import { gql } from '@apollo/client';

export const GET_OPEN_EVENTS = gql`
  query openEvents(
    $specialist: ID, 
    $meeting: String, 
    $specialists: [ID]
  ) {
    openEvents(
      specialist: $specialist,
      meeting: $meeting,
      specialists: $specialists
    ) {
      id
      pk
      startDate
      endDate
      specialist {
        id
      }
      address {
        town
        district
      }
      service {
        id
        meetingType
      }
    }
  }
`

export const GET_CLOSEST_EVENT = gql`
query openEvents {
    openEvents(
      limit: 1
    ) {
      startDate
    }
  }
`
